// @ts-nocheck
/* eslint-disable */
export const icoGripIcon = {
    data: `<svg xmlns="http://www.w3.org/2000/svg" fill="currentColor" viewBox="0 0 10 14"><path d="M2.5 3.6a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2m5 0a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2m-5 4.5a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2m5 0a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2m-5 4.5a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2m5 0a1.1 1.1 0 1 0 0-2.2 1.1 1.1 0 0 0 0 2.2"/></svg>`,
    name: 'ico-grip' as const
};